import React, { useRef, useState } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import { SyncCDR } from "../../../services/clearing/transactions";
import { getAllBills, resumeAllBills } from "../../../services/clearing/bills";

import useToastActionWrapper from "../../../hooks/useToastActionWrapper";

import { UnregisteredEmpsSection } from "./UnregisteredEmpsSection";
import { UnassignedStationsSection } from "./UnassignedStationsSection";

import { EmpBillsValidationButton } from "./Validation/EmpBillsValidationButton";
import { GenerateAllEmpBillsDialog } from "../../Customer/components/GenerateAllEmpBillsDialog";
import BankTransferXmlsButton from "../../Customer/components/BankTransferXmlsButton/BankTransferXmlsButton";
import MissingVatIdSection from "./MissingVatIdSection";
import MonthlyPaymentSumsSection from "./PaymentSums/MonthlyPaymentSumsSection";
import CollapsibleSection from "../../../components/CollapsibleSection";

export default function ClearingActions() {
  const toast = useRef(null);
  const [generateBillsDialogVisible, setGenerateBillsDialogVisible] =
    useState(false);
  const [resumeBillsDialogVisible, setResumeBillsDialogVisible] =
    useState(false);

  const { toastActionWrapper } = useToastActionWrapper(toast);

  return (
    <>
      <Toast ref={toast} className="z-10" />

      <MonthlyPaymentSumsSection toastRef={toast} />

      <GenerateAllEmpBillsDialog
        visible={generateBillsDialogVisible}
        onClose={() => setGenerateBillsDialogVisible(false)}
        toastRef={toast}
        header="Generate All EMP Bills"
        buttonLabel="Generate All EMP Bills"
        buttonIcon="pi pi-money-bill"
        action={getAllBills}
        successMessageBuilder={(monthName, year) =>
          `Successfully triggered EMP bills generation for ${monthName} ${year}!`
        }
        errorMessage="Failed to generate EMP bills!"
      />
      <GenerateAllEmpBillsDialog
        visible={resumeBillsDialogVisible}
        onClose={() => setResumeBillsDialogVisible(false)}
        toastRef={toast}
        header="Resume EMP Bills Generation"
        buttonLabel="Resume EMP Bills Generation"
        buttonIcon="pi pi-replay"
        action={resumeAllBills}
        successMessageBuilder={(monthName, year) =>
          `Successfully resumed EMP bills generation for ${monthName} ${year}!`
        }
        errorMessage="Failed to resume EMP bills generation!"
      />
      <CollapsibleSection title="Actions" storageKey="clearing.actions">
        <div className="flex flex-column gap-2 md:flex-row justify-content-start align-items-center flex-wrap">
          <Button
            className="w-12rem h-4rem"
            label="Sync CDRs from eRound"
            icon="pi pi-sync"
            outlined
            onClick={() =>
              toastActionWrapper({
                action: SyncCDR,
                successMessage: "CDR synced successfully!",
                errorMessage: "Failed to sync CDR.",
              })
            }
          />

          <Button
            className="w-16rem h-4rem"
            label="Generate All EMP Bills"
            icon="pi pi-money-bill"
            onClick={() => setGenerateBillsDialogVisible(true)}
          />

          <Button
            className="w-16rem h-4rem"
            label="Resume EMP Bills Generation"
            icon="pi pi-replay"
            onClick={() => setResumeBillsDialogVisible(true)}
          />

          <BankTransferXmlsButton />

          <EmpBillsValidationButton />
        </div>
      </CollapsibleSection>

      <UnregisteredEmpsSection />

      <UnassignedStationsSection />

      <MissingVatIdSection toastRef={toast} />
    </>
  );
}
